import { EFormType } from './types'

export const FORM_TYPES = {
  [EFormType.questions]: 'Вопрос',
  [EFormType.feedbacks]: 'Отзыв',
  [EFormType.responsesFeedbacks]: 'Ответ',
  [EFormType.responsesQuestions]: 'Ответ',
}

export const textContent = {
  questions: {
    titleForms: ['вопрос', 'вопроса', 'вопросов'],
    createButtonText: 'Задать вопрос',
    rateThunk: 'rateQuestions',
    fetchThunk: 'fetchQuestions',
    sendThunk: 'sendQuestion',
  },
  feedbacks: {
    titleForms: ['отзыв', 'отзыва', 'отзывов'],
    createButtonText: 'Написать отзыв',
    rateThunk: 'rateFeedback',
    fetchThunk: 'fetchFeedbacks',
    sendThunk: 'sendFeedback',
  },
}

export const questionHighlighting = [
  { borderRadius: '0 0 20px 20px' },
  { backgroundColor: 'rgba(3, 15, 35, .09)' },
  { backgroundColor: 'white' },
]

export const questionHighlightingParams = {
  duration: 4000,
  iterations: 1,
}
